import { Link } from "@remix-run/react";
import { ChevronDown, Globe } from "lucide-react";
import { Button } from "./button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";
import { languages, useCurrentLanguage, getPathForLanguage, type LanguageOption } from "~/lib/language";

export function LanguageSwitcher() {
  const { currentLanguage, pathname } = useCurrentLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 px-2">
          <Globe className="h-4 w-4 mr-1" />
          <span className="hidden sm:inline mr-1">{currentLanguage.flag}</span>
          <span className="hidden sm:inline text-sm">{currentLanguage.name}</span>
          <span className="sm:hidden text-sm">{currentLanguage.flag}</span>
          <ChevronDown className="h-3 w-3 ml-1" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {languages.map((lang) => (
          <DropdownMenuItem key={lang.code} asChild>
            <Link
              to={getPathForLanguage(pathname, lang)}
              className={`flex items-center w-full px-2 py-1.5 text-sm hover:bg-slate-100 dark:hover:bg-slate-800 ${
                currentLanguage.code === lang.code ? 'bg-slate-100 dark:bg-slate-800' : ''
              }`}
            >
              <span className="mr-2">{lang.flag}</span>
              <span>{lang.name}</span>
              {currentLanguage.code === lang.code && (
                <span className="ml-auto text-xs text-muted-foreground">✓</span>
              )}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
} 